export function getProductImageAltText(
    productOrVariantName: string,
    brandName?: string | null,
    designerName?: string | null,
    companyName?: string,
) {
    const values = [
        productOrVariantName,
        brandName,
        designerName,
        companyName,
    ].filter(Boolean);

    return values.join(' - ');
}
